export default __webpack_public_path__ + "static/media/logo.6555be3c.jpg";